<div class="order-info-partial">
  <div class="fw-bold mb-2 d-none d-sm-block">
    <span [translate]="'common.order.number'"></span> {{ order.multiOrder.number }}
  </div>

  <div class="mt-1 font-md d-sm-none">
    <span [translate]="'common.order.number'"></span>:
    <strong>{{ order.multiOrder.number }}</strong>
  </div>

  @if (isGiftDelivery) {
    <ng-container *ngTemplateOutlet="giftDelivery"></ng-container>
  }
  @if (isPickupDelivery) {
    <ng-container *ngTemplateOutlet="pickupDelivery"></ng-container>
  }
  @if (isToDoorDelivery) {
    <ng-container *ngTemplateOutlet="toDoorDelivery"></ng-container>
  }

  @if (isCustomerView) {
    <div class="mt-1 font-md">
      <span [translate]="'common.order.paymentMethod'">Payment method</span>:
      <strong>{{ order.multiOrder.payment.paymentName }}</strong>
    </div>
  }
</div>

<ng-template #giftDelivery>
  @if (order.deliveryOrder.deliveryUserName) {
    <div class="mt-1 font-md">
      <span [translate]="'receipt.recipient'"></span>:
      <strong>{{ order.deliveryOrder.deliveryUserName }}</strong>
    </div>
  }

  @if (order.deliveryOrder.deliveryPhone) {
    <div class="mt-1 font-md">
      <span [translate]="'receipt.contactPhone'"></span>:
      <strong>{{ order.deliveryOrder.deliveryPhone }}</strong>
    </div>
  }

  @if (order.deliveryOrder.deliveryEmail) {
    <div class="mt-1 font-md">
      <span [translate]="'receipt.recipientEmail'"></span>:
      <strong>{{ order.deliveryOrder.deliveryEmail }}</strong>
    </div>
  }

  @if (order.deliveryOrder.messageToRecipient) {
    <div class="mt-1 font-md">
      <span [translate]="'receipt.messageToRecipient'"></span>:
      <strong>{{ order.deliveryOrder.messageToRecipient }}</strong>
    </div>
  }
</ng-template>

<ng-template #toDoorDelivery>
  @if (order.deliveryOrder.deliveryDate && order.deliveryOrder.deliveryTime) {
    <div class="mt-1 font-md">
      <span [translate]="'common.delivery.deliveryTime'"></span>:
      <strong>
        {{ order.deliveryOrder.deliveryDate | i18nDate : 'dddd D.' }}
        <span class="text-lowercase">
          {{ order.deliveryOrder.deliveryDate | i18nDate : 'MMM' }}
        </span>
        {{ order.deliveryOrder.deliveryTime }}
      </strong>
    </div>
  }

  <div class="mt-1 font-md">
    <span [translate]="'common.delivery.deliveryAddress'"></span>:
    <strong>
      {{ order.deliveryOrder.deliveryAddress }},&nbsp;
      {{ order.deliveryOrder.deliveryPostNumber }}&nbsp;
      {{ order.deliveryOrder.deliveryCity }}
    </strong>
  </div>

  @if (order.deliveryOrder.deliveryUserName) {
    <div class="mt-1 font-md">
      <span [translate]="'receipt.recipient'"></span>:
      <strong>{{ order.deliveryOrder.deliveryUserName }}</strong>
    </div>
  }

  @if (order.deliveryOrder.deliveryPhone) {
    <div class="mt-1 font-md">
      <span [translate]="'receipt.contactPhone'"></span>:
      <strong>{{ order.deliveryOrder.deliveryPhone }}</strong>
    </div>
  }
</ng-template>

<ng-template #pickupDelivery>
  @if (order.deliveryOrder.deliveryDate && order.deliveryOrder.deliveryTime) {
    <div class="mt-1 font-md">
      <span [translate]="'receipt.pickupTime'">Pickup time</span>:
      <strong>
        {{ order.deliveryOrder.deliveryDate | i18nDate : 'dddd D.' }}
        <span class="text-lowercase">
          {{ order.deliveryOrder.deliveryDate | i18nDate : 'MMM' }}
        </span>
        {{ order.deliveryOrder.deliveryTime }}
      </strong>
    </div>
  }

  <div class="mt-1 font-md">
    <span [translate]="'receipt.bakery'">Bakery</span>:
    <strong>{{ order.bakery.name }}</strong>
  </div>

  <div class="mt-1 font-md">
    <span [translate]="'receipt.pickupPoint'">Store</span>:
    <strong>{{ order.deliveryOrder.outlet.name }}</strong>
  </div>

  <div class="mt-1 font-md">
    <span [translate]="'receipt.pickupPointAddress'">Store address</span>:
    <strong>
      {{ order.deliveryOrder.outlet.address }},
      {{ order.deliveryOrder.outlet.postNumber }}&nbsp;
      {{ order.deliveryOrder.outlet.cityName }}&nbsp;
    </strong>
  </div>
</ng-template>
